import { setIsOnDoNotSellShareList } from '@farmersdog/lead-browser-storage';

import type { FullLeadViewFragment } from '../../../../graphql/types';

export const handleLeadConsent = (lead: FullLeadViewFragment): void => {
  if (typeof lead.consent?.dnss === 'boolean') {
    setIsOnDoNotSellShareList(lead.consent.dnss);
  }
};
